var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStargazerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 43.75C24.125 43.75 18 41.125 18 39.375C19.3127 39.375 21.0625 39.375 22.375 38.0625C27.625 38.9375 29.375 38.9375 34.625 38.0625C35.9375 39.375 38.125 39.375 39 39.375C39 41.125 32.875 43.75 32.875 43.75V48.125L28.5 50.75L24.125 48.125L24.125 43.75Z",
    fill: "url(#paint0_radial_5567_15350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4531 35.3555C39.875 33.9336 39.875 27.5352 39.875 27.5352C39.875 21.2016 35.7141 12.25 28.4999 12.25C20.4477 12.25 17.125 21.2016 17.125 27.5352C17.125 27.5352 17.125 33.9336 18.5471 35.3555C20.0298 36.838 23.168 37.8437 28.4999 37.8437C33.8319 37.8437 36.8198 36.9888 38.4531 35.3555ZM35.9304 28.8821C36.9127 28.4274 37.9798 27.9335 38.3778 26.8033C39.0847 24.796 34.7613 14.3828 28.5002 14.3828C21.5119 14.3828 17.929 25.4635 18.6347 26.8033C18.9877 27.4734 19.8698 27.9753 20.7515 28.4771C21.6328 28.9786 22.5138 29.48 22.8663 30.1489C23.5714 31.4871 26.392 32.1562 28.5059 32.1562C30.6197 32.1562 33.4435 31.4871 34.1486 30.1489C34.4567 29.5642 35.1681 29.2349 35.9304 28.8821Z",
    fill: "url(#paint1_linear_5567_15350)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3775 26.8033C37.6706 28.8107 34.8535 28.8107 34.1484 30.1489C33.4432 31.4871 30.6195 32.1562 28.5056 32.1562C26.3918 32.1562 23.5712 31.4871 22.866 30.1489C22.1609 28.8107 19.3402 28.1431 18.6345 26.8033C17.9287 25.4635 21.5117 14.3828 28.5 14.3828C34.761 14.3828 39.0844 24.796 38.3775 26.8033Z",
    fill: "url(#paint2_radial_5567_15350)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M38.3774 26.8033C37.6705 28.8107 34.8534 28.8107 34.1483 30.1489C33.4431 31.4871 30.6194 32.1562 28.5055 32.1562C26.3916 32.1562 23.5711 31.4871 22.8659 30.1489C22.1608 28.8107 19.3401 28.1431 18.6344 26.8033C17.9286 25.4635 21.5173 17.5 28.5056 17.5C34.7667 17.5 39.0843 24.796 38.3774 26.8033Z",
    fill: "url(#paint3_linear_5567_15350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.339 19.8714L24.4817 21.103L26.155 20.9523L24.9234 22.095L25.074 23.7682L23.9314 22.5366L22.2581 22.6873L23.4897 21.5447L23.339 19.8714Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.345 19.7574L33.0903 20.8481L33.7973 21.7167L32.7066 21.462L31.838 22.169L32.0927 21.0784L31.3857 20.2097L32.4764 20.4644L33.345 19.7574Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.4492L29.2681 17.5249L31.3437 18.293L29.2681 19.061L28.5 21.1367L27.7319 19.061L25.6562 18.293L27.7319 17.5249L28.5 15.4492Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4995 45.9908L25.8749 47.505L25.8749 44.4766L28.4995 45.9908Z",
    fill: "url(#paint4_linear_5567_15350)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 44.4767L28.4999 45.9909L28.4999 42.9625L31.1245 44.4767Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8745 47.505L28.4991 45.9908L28.4991 49.0192L25.8745 47.505Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1245 47.5051L28.4999 49.0193L28.4999 45.9909L31.1245 47.5051Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8745 44.4767L28.4991 42.9625L28.4991 45.9909L25.8745 44.4767Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4995 45.9908L31.1241 44.4766L31.1241 47.505L28.4995 45.9908Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4997 0L52.7484 14V42L28.4997 56L4.25098 42V14L28.4997 0ZM6.87598 15.5155L28.4997 3.03109L50.1234 15.5155V40.4845L47.5944 41.9446C46.5291 41.566 40.3079 39.375 38.9998 39.375C38.9998 41.125 32.8748 43.75 32.8748 43.75V48.125L28.4998 50.7911L24.1248 48.125V43.75C24.1248 43.75 17.9998 41.125 17.9998 39.375C16.6916 39.375 10.4701 41.5661 9.40506 41.9446L6.87598 40.4845V15.5155Z",
    fill: "url(#paint5_linear_5567_15350)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5567_15350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5 47.7969) rotate(-90) scale(8.53125 7.99805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5567_15350",
    x1: 31.5625,
    y1: 25.375,
    x2: 40.3125,
    y2: 34.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5567_15350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5 17.582) rotate(89.976) scale(16.9161 10.2115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5567_15350",
    x1: 28.5,
    y1: 17.5,
    x2: 28.5,
    y2: 46.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5567_15350",
    x1: 25.8749,
    y1: 44.4685,
    x2: 27.1872,
    y2: 46.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5567_15350",
    x1: 28.4998,
    y1: 24.0625,
    x2: 57.8113,
    y2: 53.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargazerLogo);
export default __webpack_public_path__ + "static/media/StargazerLogo.b065123347927b559ecc23fd362daa7c.svg";
export { ForwardRef as ReactComponent };